export const UPDATE_SEARCH = "UPDATE_SEARCH"

export function updateSearch(payload) {

    return {
        type: UPDATE_SEARCH,
        payload: payload
    }
}